import { render } from "./ProjectView.vue?vue&type=template&id=06e0a92d"
const script = {}

import "./ProjectView.vue?vue&type=style&index=0&id=06e0a92d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__